import { classes } from "../../../../../shared/react/react"
import { type View } from "../state"
import { GenericProps } from "../types"

const ownerViews: readonly { id: View, text: string }[] = [
    { id: "users", text: "Users" },
    { id: "permissions", text: "Permissions" },
    { id: "cropping", text: "Cropping" },
    { id: "invites", text: "Invitations" },
] as const

const memberViews: readonly { id: View, text: string }[] = [
    { id: "users", text: "Users" },
    { id: "permissions", text: "Permissions" },
] as const

export function Views({ state, dispatch }: GenericProps) {

    const { loggedInUser: { ownerRole } } = state

    const views = ownerRole
        ? ownerViews
        : memberViews

    const select = (payload: View) => dispatch({ type: "setView", payload })


    return <ul className="flex-row views">
        {
            views.map(v => <View key={v.id} id={v.id} text={v.text} current={state.view === v.id} select={select} />)
        }
    </ul>
}

function View({ id, text, select, current }: { id: View, text: string, current: boolean, select: (view: View) => void }) {

    return <li className={classes(current && "selected")}>
        <button type="button" className="btn btn-link" onClick={() => select(id)}>
            {text}
        </button>
    </li>
}
